import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {BrandHubPageService_GetCategoriesLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.grpc.lazy';
import {useIsMultiBrand} from '@aboutyou/router';
import {useAnyFilterFlyoutOpened} from '../../../features/Filters/shared/useAnyFilterFlyoutOpened';
import {useAppliedPotentialFilters} from '../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {
  useBrandShopCacheKeyTransformer,
  useBrandShopIdentifier,
} from './useBrandShopIdentifier';
import {useCategoryIdentifier} from './useCategoryIdentifier';

export const useFiltersHeaderData = () => {
  const brandIdentifier = useBrandShopIdentifier();
  const targetGroup = useTargetGroupIdentifier();
  const appliedFilters = useAppliedPotentialFilters();
  const categoryIdentifier = useCategoryIdentifier();
  const isFilterFlyoutOpen = useAnyFilterFlyoutOpened();
  const isMultiBrand = useIsMultiBrand();
  const brandShopCacheKeyTransformer = useBrandShopCacheKeyTransformer();

  return useGrpcRequest(
    BrandHubPageService_GetCategoriesLazy,
    {
      brand: {
        identifier: brandIdentifier,
      },
      targetGroup,
      appliedFilters: {
        filters: appliedFilters,
      },
      category: categoryIdentifier ?? null,
      isMultiBrand,
      reductionsState: useReductionsStateRequestParameter(),
    },
    {
      disabled: isFilterFlyoutOpen,
      keepPreviousData: true,
      transformCacheKey: brandShopCacheKeyTransformer,
    },
  );
};
